/**
 * Registriert den Service Worker, der die App installierbar macht.
 *
 * Nur in Produktionsbuilds: im Dev-Server wuerde ein dazwischenliegender
 * Service Worker das Hot Module Replacement von Vite stoeren.
 */
export const registerServiceWorker = () => {
  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      // Ohne Service Worker funktioniert die App normal weiter - nur die
      // Installations-Aufforderung von Chrome/Edge entfaellt.
      console.warn('Service Worker konnte nicht registriert werden:', error);
    });
  });
};
